import type { MotionTrack } from '~/lib/motion'
import { ShimmerBand } from './shimmer-band'

// The starter pack shimmer's loop (GLOSSARY.md "Starter pack shimmer (掃光)"),
// from the design's motion data: 14 seconds, of which only 0.3–0.8 s moves.
const SHIMMER_CYCLE_MS = 14_000

const at = (ms: number) => ms / SHIMMER_CYCLE_MS
const SWEEP_EASING = 'cubic-bezier(0.5, 0, 0.5, 1)'

// The band holds off-card for 0.3 s, then sweeps 720px right — past the
// widest card — fading in on the way out of the left edge and out again
// before it leaves; it tilts from -18° towards -34° and widens 5% as it
// goes. The rest of the cycle it waits, invisible.
const SHIMMER_TRACKS: MotionTrack[] = [
  {
    property: 'translate',
    values: ['0px 0px', '0px 0px', '720px 0px', '720px 0px'],
    times: [0, at(300), at(800), 1],
    easing: ['linear', SWEEP_EASING, 'linear'],
  },
  {
    property: 'opacity',
    values: [0, 0, 1, 1, 0, 0],
    times: [0, at(300), at(368), at(708), at(800), 1],
    easing: ['linear', 'ease-out', 'linear', 'ease-out', 'linear'],
  },
  {
    property: 'rotate',
    values: ['-18deg', '-32.32deg', '-33.69deg', '-33.69deg'],
    times: [0, at(276), at(503), 1],
    easing: [SWEEP_EASING, SWEEP_EASING, 'linear'],
  },
  {
    property: 'scale',
    values: ['1 1', '1.05 1', '1.05 1'],
    times: [0, at(503), 1],
    easing: 'linear',
  },
]

// The starter pack card's band: it starts sweeping when it mounts.
export function StarterPackShimmer() {
  return (
    <ShimmerBand
      cycleMs={SHIMMER_CYCLE_MS}
      testId="starter-pack-shimmer"
      tracks={SHIMMER_TRACKS}
    />
  )
}
